// External ThirdEye learning portal (separate app/domain).
export const PORTAL_URL = 'https://thirdeyecybersecurity.app/';
